import React from "react";
import {
  View,
  StyleSheet,
  SafeAreaView,
  Platform,
  Linking,
} from "react-native";
import { AppText } from "./AppText";
import { ActionButton } from "./ActionButton";
import { Colors } from "@/constants/Colors";
import Icons from "@/assets/icons";
import { FontFamilies } from "@/constants/Typography";

const AppRequireUpdate = () => {
  const handleUpdatePress = () => {
    if (Platform.OS === "ios") {
      // iOS App Store link - replace with your actual app ID when available
      Linking.openURL("https://apps.apple.com/app/id6749118997");
    } else {
      // Google Play Store link using the package name from app config
      Linking.openURL(
        "https://play.google.com/store/apps/details?id=com.usesparrow.sparrow"
      );
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <Icons.LogoBlack width={120} height={120} />
        </View>

        <AppText type="title" style={styles.title}>
          Update Required
        </AppText>

        <AppText type="subtitle" style={styles.subtitle}>
          Please update Sparrow to continue
        </AppText>

        <AppText style={styles.description}>
          A new version of Sparrow is available with important improvements and
          bug fixes. Please update to the latest version to continue using the
          app.
        </AppText>

        <View style={styles.buttonContainer}>
          <ActionButton
            title={
              Platform.OS === "ios"
                ? "Update on App Store"
                : "Update on Google Play"
            }
            type="primary"
            onPress={handleUpdatePress}
          />
        </View>

        <AppText style={styles.thankYou}>Thank you for using Sparrow!</AppText>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.background,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
  },
  iconContainer: {
    marginBottom: 24,
  },
  title: {
    textAlign: "center",
    color: Colors.text,
    fontFamily: FontFamilies.Inter.Medium,
    marginBottom: 8,
  },
  subtitle: {
    textAlign: "center",
    color: Colors.icon,
    marginBottom: 24,
    fontFamily: FontFamilies.Inter.Regular,
  },
  description: {
    textAlign: "center",
    color: Colors.text,
    lineHeight: 24,
    marginBottom: 32,
    maxWidth: 320,
    fontFamily: FontFamilies.InterTight.Regular,
  },
  buttonContainer: {
    width: "100%",
    paddingHorizontal: 20,
    marginBottom: 24,
  },
  thankYou: {
    textAlign: "center",
    color: Colors.primary,
    fontWeight: "600",
    fontFamily: FontFamilies.InterTight.Medium,
  },
});

export default AppRequireUpdate;
